import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,_vm._l((_vm.getItems),function(item,index){return _c(VCol,{key:index,attrs:{"cols":"12","md":"4"}},[_c('product-stock',{attrs:{"product":item.product,"in-stock":item.quantity,"minimum":item.minimum,"readonly":""}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }